import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlComponent } from './form-control/form-control.component';
import { PipesModule } from '../../common/pipes/pipes.module';
import { LunaCommonModule } from '../../common/common.module';
import { LunaInputDirective } from './form-control/luna-input.directive';
import { FormControlLabelComponent } from './form-control/form-control-label/form-control-label.component';

@NgModule({
  imports: [
      CommonModule,
      PipesModule,
      LunaCommonModule
  ],
    declarations: [
        FormControlComponent,
        LunaInputDirective,
        FormControlLabelComponent
    ],
    exports: [
        FormControlComponent,
        LunaInputDirective,
        FormControlLabelComponent
    ]
})
export class FormControlBaseModule { }
